/**
 *
 */

import React, { useState, useEffect } from "react";

/* Import configuration starts */
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
/* Import configuration ends */

/* Import redux slices component starts */
/* Import redux slices component ends */

/* Import react bootstrap component starts */
/* Import react bootstrap component ends */

/* Import image and SVG starts */
/* Import image and SVG ends */

/* Import local pages and component starts */
import DetailCard from "./sub-component/DetailCard";
import TimeLineLists from "./sub-component/TimeLineLists";
/* Import local pages and component ends */

import "./style.scss";

/* Component starts */
const MoveInMaintenanceDetail = (props) => {
  /* Props destructuring starts */
  const {
    maintenance_id,
    maintenance,
    type,
    mgmtModel,
    isT1,
    isT2,
    isT3,
    status,
    property,
    user,
  } = props;
  /* Props destructuring ends */

  /* Component states and useRef declaration starts */
  /* Component states and useRef declaration ends */

  /* Other hooks declaration starts */
  const dispatch = useDispatch();
  // Redux Selector
  /* Other hooks declaration ends */

  /* Component variable declaration / object destructure starts */
  const name =
    maintenance?.assigned?.first_name + " " + maintenance?.assigned?.last_name;
  /* Component variable declaration / object destructure ends */

  /* Component function definition starts */
  /* Component function definition ends */

  /* Component useEffect starts */
  /* Component useEffect ends */

  /* ************* Component rendering. JSX code ************* */
  return (
    <div className="maintenance-detail-component-wrapper container_sm">
      <h1 className="text-center font_xxl">Maintenance Request Detail</h1>

      {/* Details */}
      <DetailCard
        type={type}
        isT1={isT1}
        isT2={isT2}
        isT3={isT3}
        status={status}
        mgmtModel={mgmtModel}
        maintenance={maintenance}
      />

      {/* Timeline */}
      <TimeLineLists
        isT1={isT1}
        isT2={isT2}
        isT3={isT3}
        status={status}
        mgmtModel={mgmtModel}
        maintenance={maintenance}
        maintenance_id={maintenance_id}
        logs={maintenance?.logs}
        property={property}
        user={user}
      />
    </div>
  );
};
/* Component ends */

export default MoveInMaintenanceDetail;
